export default __webpack_public_path__ + "a541fdd56943895e5c715f1f544b0197.png";